import React from "react";

const PainPointsSection = () => {
	const leftHeading = "What's slowing you down:";
	const rightHeading = "What you're still on the hook for:";
	const outcomeText = "Delivering outcomes the<br/>business can feel.";
	const painPoints = [
		"Your team can't move as fast as the business (or AI) is evolving.",
		"Talent gaps slow everything down — product, design, engineering, QA, DevOps.",
		"Legacy systems and clunky UX frustrate users and sink adoption.",
		"Contractors are unreliable. Hiring is slow. Fixed-bid shops don't understand your roadmap.",
	];

	return (
		<div className="container mx-auto py-[clamp(40px,6.25vw,80px)] px-2 xl:px-0 max-w-6xl">
			{/* Mobile Layout: Grouped heading + content */}
			<div className="lg:hidden">
				<div className="flex flex-col">
					{/* Left Column: What's slowing you down */}
					<div>
						<div className="border-b border-gray-light py-6">
							<p className="text-[clamp(20px,1.5vw,24px)] font-normal">{leftHeading}</p>
						</div>
						<div className="py-[clamp(12px,1.56vw,20px)] border-b border-gray-light">
							<div className="space-y-2">
								{painPoints.map((point, index) => (
									<div
										key={index}
										className="bg-blue/10 p-[10px] rounded-lg text-base "
									>
										{point}
									</div>
								))}
							</div>
						</div>
					</div>

					{/* Right Column: What you're still on the hook for */}
					<div>
						<div className="border-b border-gray-light py-6">
							<p className="text-[clamp(20px,1.5vw,24px)] font-normal">{rightHeading}</p>
						</div>
						<div className="py-[clamp(12px,1.56vw,20px)] border-b border-gray-light h-full flex flex-col">
							<div className="bg-green/10 rounded-xl p-[clamp(12px,1.56vw,20px)] flex items-center justify-center flex-grow">
								<h2 className="text-[clamp(20px,1.88vw,24px)] font-bold text-center leading-tight">
									<span dangerouslySetInnerHTML={{ __html: outcomeText }} />
								</h2>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Desktop Layout: Headers row + Content row */}
			<div className="hidden lg:block">
				{/* Headers Row */}
				<div className="grid grid-cols-2 border-b border-gray-light">
					<div className="border-r border-gray-light py-6 pr-12">
						<p className="text-[clamp(20px,1.5vw,24px)] font-normal">{leftHeading}</p>
					</div>
					<div className="py-6 pl-[clamp(12px,1.56vw,20px)]">
						<p className="text-[clamp(20px,1.5vw,24px)] font-normal">{rightHeading}</p>
					</div>
				</div>

				{/* Content Row */}
				<div className="grid grid-cols-2 border-b border-gray-light">
					<div className="border-r border-gray-light py-[clamp(12px,1.56vw,20px)] pr-[clamp(12px,1.56vw,20px)]">
						<div className="space-y-2">
							{painPoints.map((point, index) => (
								<div
									key={index}
									className="bg-blue/10 p-[10px] rounded-lg text-base "
								>
									{point}
								</div>
							))}
						</div>
					</div>

					<div className="py-[clamp(12px,1.56vw,20px)] pl-[clamp(12px,1.56vw,20px)] h-full flex flex-col">
						<div className="bg-green/10 rounded-xl p-[clamp(12px,1.56vw,20px)] flex items-center justify-center flex-grow">
							<h2 className="text-[clamp(20px,1.88vw,24px)] font-bold text-center leading-tight">
								<span dangerouslySetInnerHTML={{ __html: outcomeText }} />
							</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PainPointsSection;
